import { createContext } from 'react';
import { initialState } from './entityReducer';

const EntityContext = createContext({
  state: initialState(),
});

export default EntityContext;
